import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../IndividualPlan/tokens';

export const HeadlineCardRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: 8,
  padding: 16,
  borderRadius: 8,
  backgroundColor: COLORS.bg,
});
